<template>
  <v-form>
    <h2><b></b></h2>
    <v-row>
      <v-col cols="12"><v-text-field :disabled="preview" @change="onChange" v-model="props.General.BatchDeleteTime" :label="$t('json.appBatchDeleteTime')" :rules="rules.BatchDeleteTime" required validate-on-blur ></v-text-field></v-col>
    </v-row>
  </v-form>
</template>
<script>

export default {
  name: 'ApplicationSettings',
  props: {
    props: {
      type: Object,
      default: null
    },
    disable: {
      type: Boolean,
      default: false
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      rules: {
        BatchDeleteTime: [(v) => !!v || this.$i18n.t('json.ruleempty')]
      }
    }
  },
  methods: {
    async onChange (val) {
      this.$emit('changeSettings')
    }
  }
}
</script>
